
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Empty from "@/components/empty.vue";
import { GetDeptData, GetUserList } from "@/request/common";
import { BuildTree, GetIdArr } from "@/utils/base";
@Component({
  components: {
    Empty,
  },
})
export default class Name extends Vue {
  @Prop()
  private current: any;
  @Prop()
  private visible: any;
  @Watch("visible", { immediate: true })
  private visibleChange() {
    this.ifShowShareSelect = this.visible;
    if (this.ifShowShareSelect) {
      this.selectedDept = this.current.dept;
      this.selectedUser = this.current.user;
      this.getDept();
    }
  }
  private ifShowShareSelect: any = false;
  private deptData: any = [];
  private userData: any = [];
  private selectedDept: any = [];
  private selectedUser: any = [];
  private ifSelectAll: any = false;
  private selectSearchText: any = "";
  private cDept: any = {};
  private defaultProps: any = {
    children: "children",
    label: "name",
  };
  private cancel() {
    this.$emit("cancel");
  }
  private goShowUser(item: any) {
    this.cDept = item;
    this.getUser();
  }
  private handleCheckChange(data: any, checked: any, indeterminate: any) {
    this.selectedDept = (this.$refs.shareTree as any).getCheckedNodes();
  }
  private selectAll() {
    this.userData.forEach((ele: any) => {
      const index = this.selectedUser.findIndex((val: any) => {
        return val.uid == ele.uid;
      });
      if (this.ifSelectAll && index === -1) {
        // 选择全部
        this.selectedUser.push(ele);
      } else if (!this.ifSelectAll && index !== -1) {
        // 取消全部
        this.selectedUser.splice(index, 1);
      }
    });
  }
  private delOneDept(uid: any) {
    const index = this.selectedDept.findIndex((val: any) => {
      return val.uid == uid;
    });
    this.selectedDept.splice(index, 1);
    this.updataDeptSelect();
  }
  private deptChange(item: any) {
    const index = this.selectedDept.findIndex((val: any) => {
      return val.uid == item.uid;
    });
    if (index == -1) {
      this.selectedDept.push(item);
    } else {
      this.selectedDept.splice(index, 1);
    }
  }
  private selectChange(item: any) {
    const index = this.selectedUser.findIndex((val: any) => {
      return val.uid == item.uid;
    });
    if (index == -1) {
      this.selectedUser.push(item);
    } else {
      this.selectedUser.splice(index, 1);
    }
  }
  private delOneSelect(index: any) {
    this.selectedUser.splice(index, 1);
    this.$forceUpdate();
  }
  private ifChecked(item: any, arr: any) {
    const index = arr.findIndex((val: any) => {
      return val.uid == item.uid;
    });
    if (index != -1) {
      return true;
    } else {
      return false;
    }
  }
  private updataDeptSelect() {
    const arr: any = GetIdArr(this.selectedDept, "uid");
    console.log("更新选中");
    console.log(arr);
    if (this.$refs.shareTree) {
      (this.$refs.shareTree as any).setCheckedKeys(arr);
    }
  }
  private saveShareSelect() {
    const data: any = {
      dept: this.selectedDept,
      user: this.selectedUser,
    };
    this.$emit("change", data);
  }
  private getDept(item?: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {},
    };
    GetDeptData(this, params, loading).then((res: any) => {
      loading.close();
      if (res.data.length > 0) {
        res.data.forEach((ele: any) => {
          ele.uid = "dept" + ele.id;
          ele.type = "dept";
        });
      }
      let d: any = BuildTree(res.data);
      this.deptData = d;
      console.log(this.deptData);
      setTimeout(() => {
        this.updataDeptSelect();
      }, 100);
    });
  }
  private getUser() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetUserList(this, { params: { dept: this.cDept.id } }, loading).then(
      (user: any) => {
        user.data.forEach((ele: any) => {
          ele.uid = "user" + ele.id;
          ele.type = "user";
        });
        this.userData = user.data;
      }
    );
  }
  private searchData() {
    if (!this.selectSearchText) {
      this.cDept = {};
      this.getDept();
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        search: this.selectSearchText,
      },
    };
    GetDeptData(this, params)
      .then((res: any) => {
        let d: any = res.data;
        if (d.length > 0) {
          d.forEach((ele: any) => {
            ele.uid = "dept" + ele.id;
            ele.type = "dept";
          });
        }
        this.deptData = d;
        GetUserList(this, { params: { search: this.selectSearchText } })
          .then((user: any) => {
            user.data.forEach((element: any) => {
              element.uid = "user" + element.id;
              element.type = "user";
            });
            this.userData = user.data;
            loading.close();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch(() => {
        loading.close();
      });
  }
}
